import { Icon } from '@manychat/icons'

import { NODE_PLACEHOLDER_ID } from 'common/builder/components/chart/FlowChart/constants'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartEmptyNodeBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartEmptyNodeBlock'

export class FlowChartEmptyNodeBlockBuilder {
  private block: FlowChartEmptyNodeBlock

  constructor() {
    this.block = {
      id: NODE_PLACEHOLDER_ID,
      type: FlowChartBlockType.EMPTY_NODE,
      data: {
        icon: null,
        text: '',
      },
    }
  }

  withIcon(icon: Icon | null): FlowChartEmptyNodeBlockBuilder {
    this.block.data.icon = icon
    return this
  }

  withText(text: string): FlowChartEmptyNodeBlockBuilder {
    this.block.data.text = text
    return this
  }

  build(): FlowChartEmptyNodeBlock {
    return this.block
  }
}
